module.exports = __webpack_public_path__ + "img/type_GHOST.aacf7da2.png";